import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PersonService from "../../../Services/Person.service";
const config = {
    loadOptions: PersonService.searchEnabledNonStudent,
    value: "personId",
    label: "fullName",
};
export const StaffSearch = makeSearch(config);
export const StaffMultiSearch = makeMultiSearch(config);
